import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { DateTime } from 'luxon'

import {
  StatusBadge, Table, Text,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import formatDate from '@functions/formatDate'

import PublicationEditionActions from '../PublicationEditionActions'

const buildColumns = () => [
  {
    title: 'Title',
    dataKey: 'title',
    cellProps: {
      position: 'sticky',
      left: 0,
    },
    render: title => (
      <Text key={title} variant="ellipsis" width={80}>
        {title}
      </Text>
    ),
  },
  {
    title: 'Published',
    dataKey: 'publication_date',
    render: date => (
      <Text key={date} variant="ellipsis" width={80}>
        {date}
      </Text>
    ),
  },
  {
    title: 'Booking',
    dataKey: 'dates',
    render: (dates) => {
      const bookingDate = digObject(dates, 'booking.date_time')
      const formattedDate = formatDate(bookingDate, 'dd/MM/yyyy HH:mm', 'hh:mma dd/MM/yyyy')

      return (
        <Text key={formattedDate} variant="ellipsis" width={140}>
          {formattedDate || 'N/A'}
        </Text>
      )
    },
  },
  {
    title: 'Artwork',
    cellProps: {
      key: 'artwork',
    },
    dataKey: 'dates',
    render: (dates) => {
      const artworkDate = digObject(dates, 'artwork.date_time')
      const formattedDate = formatDate(artworkDate, 'dd/MM/yyyy HH:mm', 'hh:mma dd/MM/yyyy')

      return (
        <Text key={formattedDate} variant="ellipsis" width={140}>
          {formattedDate || 'N/A'}
        </Text>
      )
    },
  },
  {
    title: 'Editorial',
    cellProps: {
      key: 'editorial',
    },
    dataKey: 'dates',
    render: (dates) => {
      const editorialDate = digObject(dates, 'editorial.date_time')
      const formattedDate = formatDate(editorialDate, 'dd/MM/yyyy HH:mm', 'hh:mma dd/MM/yyyy')

      return (
        <Text key={formattedDate} variant="ellipsis" width={140}>
          {formattedDate || 'N/A'}
        </Text>
      )
    },
  },
  {
    title: 'Inspection',
    cellProps: {
      key: 'inspection',
    },
    dataKey: 'dates',
    render: (dates) => {
      const inspectionDate = digObject(dates, 'inspection.date_time')
      const formattedDate = formatDate(inspectionDate, 'dd/MM/yyyy HH:mm', 'hh:mma dd/MM/yyyy')

      return (
        <Text key={formattedDate} variant="ellipsis" width={140}>
          {formattedDate || 'N/A'}
        </Text>
      )
    },
  },
  {
    title: 'Special',
    cellProps: {
      textAlign: 'center',
    },
    dataKey: 'special_deadline',
    render: isSpecialDeadline => (
      <Text textAlign="center" variant="ellipsis">
        {isSpecialDeadline ? 'Yes' : 'No'}
      </Text>
    ),
  },
  {
    title: 'Status',
    cellProps: {
      key: 'status',
      textAlign: 'center',
    },
    dataKey: 'publication_date',
    render: (publicationDate) => {
      const date = DateTime.fromFormat(publicationDate, 'dd/MM/yyyy')
      const isPublished = date < DateTime.now()

      return (
        <StatusBadge
          key={publicationDate}
          color={isPublished ? 'green' : 'orange'}
          ghost
          text={isPublished ? 'Published' : 'Pending'}
        />
      )
    },
  },
  {
    title: 'Actions',
    cellProps: {
      textAlign: 'center',
    },
    dataKey: 'id',
    render: id => <PublicationEditionActions publicationEdition={{ id }} />,
  },
]

const PublicationEditionsTable = (props) => {
  const { publicationEditions } = props

  const memoColumns = useMemo(() => buildColumns(), [publicationEditions.length])

  return (
    <Table
      boxProps={{ border: 'none', maxHeight: 600, overflowY: 'auto' }}
      columns={memoColumns}
      data={publicationEditions}
      stickyHeader
    />

  )
}

PublicationEditionsTable.propTypes = {
  publicationEditions: PropTypes.array.isRequired,
}

export default React.memo(PublicationEditionsTable)
